export const WELCOME_BLOCK_RENDER_FEATURE_KEY = "welcome";
export const WELCOME_BLOCK_RENDER_FEATURE_PATH = "main.children.welcome";

export const CONGRATS_RENDER_FEATURE_KEY = "congrats";
export const CONGRATS_RENDER_FEATURE_PATH = "main.children.congratulations";

export const COMPANY_INFO_RENDER_FEATURE_KEY = "company-info";
export const COMPANY_INFO_RENDER_FEATURE_PATH =
  "main.children.company.children.info";
